var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.address.street))]),_c('div',[(!_vm.separateZip)?_c('span',[_vm._v(_vm._s(_vm.address.zip))]):_vm._e(),_vm._v(" "+_vm._s(_vm.address.city)+" ")]),(_vm.separateZip)?_c('div',[_vm._v(_vm._s(_vm.address.zip))]):_vm._e(),_c('div',[_vm._v(_vm._s(_vm.address.country))])])
}
var staticRenderFns = []

export { render, staticRenderFns }